export const CLIENT_ID_MAPPING = {
  baa_baltimore: "2b409feef211.seasonshare.baabal-baa.us",
  baa_indianapolis: "fbc0d8881162.seasonshare.baaind-baa.us",
  dbacks_flex: "64dd97c850f6.seasonshare.azdbacks-azdbacks.us",
  devils_flex: "8f3880de99a0.seasonshare.devils-devils.us",
  flex_sandbox: "9905940d1e7e.seasonshare.integ3-sandbox.us",
  knicks: "14722a2f1643.seasonshare.msg-msg.us",
  magic_flex: "2af95a60a522.seasonshare.magic-magic.us",
  mwc_bball: "800f2799df20.seasonshare.mountainwest-mwtickets.us",
  msg_suite: "14722a2f1643.seasonshare.msg-msg.us",
  pistons_bundle: "77ff57c93ecf.seasonshare.pistons-pistons.us",
  pistons_holiday: "77ff57c93ecf.seasonshare.pistons-pistons.us",
  pistons_flex: "77ff57c93ecf.seasonshare.pistons-pistons.us",
  predators: "dfd8b5e4f0c4.seasonshare.predators-predator.us",
  predators_flex: "dfd8b5e4f0c4.seasonshare.predators-predator.us",
  rangers: "14722a2f1643.seasonshare.msg-msg.us",
  united_flex: "5ed9925df375.seasonshare.falcons-falcons.us",
  warriors: "a0c82f97b42c.seasonshare.warriors-warriors.us",
  dbacks_accesspass: "64dd97c850f6.seasonshare.azdbacks-azdbacks.us",
  dbacks_gift: "64dd97c850f6.seasonshare.azdbacks-azdbacks.us",
  warriors_gift: "a0c82f97b42c.seasonshare.warriors-warriors.us",
  aviators_flex: "7aada002426d.seasonshare.aviatorslv-vegas51s.us",
  dbacks_suites: "64dd97c850f6.seasonshare.azdbacks-azdbacks.us",
  flex_sandbox_warriors: "9905940d1e7e.seasonshare.integ3-sandbox.us",
  dbacks_suite: "64dd97c850f6.seasonshare.azdbacks-azdbacks.us",
  flex_sandbox_predators: "9905940d1e7e.seasonshare.integ3-sandbox.us",
  flex_sandbox_knicks: "9905940d1e7e.seasonshare.integ3-sandbox.us",
  sandbox_perks: "9905940d1e7e.seasonshare.integ3-sandbox.us",
  flex_sandbox_athletics: "9905940d1e7e.seasonshare.integ3-sandbox.us",
  timberrattlers_flex: "HfE0i9FBQDnVdlAKODLha9yCGOn4nZGcCEOF0B2Gq7CSDznr",
  flex_sandbox_mwc_bball: "800f2799df20.seasonshare.mountainwest-mwtickets.us",
  flex_sandbox_gift: "9905940d1e7e.seasonshare.integ3-sandbox.us",
  tdc_flex_sandbox: "9905940d1e7e.seasonshare.integ3-sandbox.us",
  tdc_flex_certification: "9905940d1e7e.seasonshare.integ3-sandbox.us",
  flex_sandbox_united_flex: "9905940d1e7e.seasonshare.integ3-sandbox.us",
  timberrattlersbark_flex: "HfE0i9FBQDnVdlAKODLha9yCGOn4nZGcCEOF0B2Gq7CSDznr",
  athletics_flex: "AAQM8IWieVus6zt6JN8TxajuPLshtOlyohcjU2GY6IAeMx3M",
  jaguars_flex: "70b79cf58110.seasonshare.jaguars-jaguars.us",
  flex_sandbox_suite: "64dd97c850f6.seasonshare.azdbacks-azdbacks.us",
  dbacks_hondorodeo: "64dd97c850f6.seasonshare.azdbacks-azdbacks.us",
  winnipegjets_flex: "0b4fc428390a.seasonshare.tnse-truenorth.ca",
  devils_pickem: "8f3880de99a0.seasonshare.devils-devils.us",
  dbacks_suites_clone: "64dd97c850f6.seasonshare.azdbacks-azdbacks.us",
  stlouisblues_flex: "60ba98b2d08f.seasonshare.blues-blues.us",
  texasrangers_suites: "ybNHIIRFaaGAIDlkAigJOMQcShWYMLkTlifWMcklJcZRGXHf",
  predators_pickem: "dfd8b5e4f0c4.seasonshare.predators-predator.us",
  pistons_accountrep: "77ff57c93ecf.seasonshare.pistons-pistons.us",
  devils_miniplan: "8f3880de99a0.seasonshare.devils-devils.us",
  fcs: "72e889905a8c.seasonshare.fcs-citrusbowl.us",
  baa_dallas: "dbe382ca8fb7.seasonshare.baadal-baa.us",
  baa_houston: "1f1613ca0052.seasonshare.ccethou-baa.us",
  baa_calgary: "34e6a27414ba.seasonshare.baacal-baa.ca",
  baa_edmonton: "faeb76878c58.seasonshare.baaedm-baa.ca",
  baa_vancouver: "6c86e924cdbe.seasonshare.baawdcmen-baa.ca",
  flex_sandbox_suites: "64dd97c850f6.seasonshare.azdbacks-azdbacks.us",
  brooklynnets_flex: "b8dc1b4eeef2.seasonshare.bse-bse.us",
  devils_holiday: "8f3880de99a0.seasonshare.devils-devils.us",
  predators_holiday: "dfd8b5e4f0c4.seasonshare.predators-predator.us",
  okccomets_flex: "3ec81d81ee0f.seasonshare.okcbaseball-mandalaysports.us",
  sanjosegiants_flex: "Fbjck3UDUGtFTNhpXchCkKsZBvHDAH8SLrgdJqZwqsRsVyVR",
  altoonacurve_flex: "a76ea3bfab1a.seasonshare.altoonacurve-dbh.us",
  stlouisblues_giftcards: "60ba98b2d08f.seasonshare.blues-blues.us",
  swbrailriders_flex: "1541d92591f7.seasonshare.swbyankees-dbh.us",
  memphisredbirds_flex: "wSIWJgwyB94f2NEKsfAOfG94jHnalA7euJpLtU56YeVih4Ys",
  predators_packs: "dfd8b5e4f0c4.seasonshare.predators-predator.us",
  wichitawindsurge_flex: "sJc9suqDrDpH1e5JkZFg2RLSgaJK2zSQ2I4zLfHpci1drz3e",
  inlandempire66ers_flex: "bClDrIa6rz9Srv6d0V15FEAw4xX7nqhuocY3XptDvnoYGgeT",
  albuquerqueisotopes_flex: "07ddf826a301.seasonshare.isotopes-isotopes.us",
  iowacubs_flex: "925NXCS6TtphmMBOy1zgMmd4a0s9QpkM8uwkvHlv0fTR5ZAU",
  springfieldcardinals_flex: "VcW5trLcxj6P6dANAGt1wqwcfKX34Apd6PIsSDU3dnaKPkx0",
  hickorycrawdads_flex: "yVHkb8GrSgR5bDw0vrwoHc7U5i8OJi5NAe9eWHzbKKSLuc0z",
  augustagreenjackets_flex: "cxYRPQpsQAQ8u5Ju7uCuZMGvIjvXbhIYUfbGAmxlB2B2CO8E",
  fresnogrizzlies_flex: "s3geC4NEwFJ3z4Y6wPHxV49fAgZCi1k98Xm6rl8z7828RSza",
  midlandrockhounds_flex: "fmGZp1rx3kMNB8GlGAxJzQYBfk38wAeFlreU5Dn20vo2peUf",
  tulsadrillers_flex: "3QZg2DvHWsuRm7zLDRBE8zGJjgjLQ5mbSFhw7qC5IOWbtXIM",
  vancouvercanadians_flex: "qsvivKG3L1On1WsMTTIeNUFJHk2zmRpqDe3oTU3hcJ5coUnP",
  saintpaulsaints_flex: "5srXY89z8HXtZeyEkcAGeN9d0s6CqTZxAMjBoHm8twjWMdtT",
  portlandseadogs_flex: "Ki1DiTvi8zCb8GRiepuvC3kdfXTRxrERT1aANwYgenzDucwn",
  newhampshirefishercats_flex:
    "f9ZAkh7veqSIS2cVCM3v1LKVak1vDMydEv8tAokEbKQBMR2D",
  hubcityspartanburgers_flex:
    "pFnU6ACLCnuMZQLDgDDpvJVulgPReTf9AsbVK9G8vcbx23Ea",
  worcesterredsox_flex: "cHZytxEv8hB95GznNw3lsAVHN83DOCKb2THw8qrJHu33hNUJ",
  louisvillebats_flex: "yzwH3vZoPcUBtG8g6zvRhkNDgzTn4ucObTyXNKJK0jyEGRaS",
  louisvillebats_flexpack: "yzwH3vZoPcUBtG8g6zvRhkNDgzTn4ucObTyXNKJK0jyEGRaS",
  lansinglugnuts_flex: "T4vx8zbDB00UWRA3QuwUKooi3ooSABPNGEpUw36FswlY5oSE",
  hvrenegades_flex: "05a834d73a3f.seasonshare.hvrenegades-dbh.us",
  norfolktides_flex: "da6d6b88acb3.seasonshare.tides-tides.us",
  sacramentokings_flex: "6b6c129ee955.seasonshare.sackings-sackings.us",
  winnipegjets_bizpassport: "0b4fc428390a.seasonshare.tnse-truenorth.ca",
  salemredsox_flex: "1AaJ4xLRBWLE8riAsGIVXEepGYpNtL7eoanKnoDLz5HGDcsf",
  winstonsalemdash_flex: "G4U9eHeWuiOmG1FeMsHGc2eeoqNL9TfaOh7BBPVc7AkX1BFe",
  aviators_suites: "7aada002426d.seasonshare.aviatorslv-vegas51s.us",
  devils_minipack: "8f3880de99a0.seasonshare.devils-devils.us",
  sanantoniospurs_flex: "f8bb7bfe9c46.seasonshare.spurs-spurs.us",
  stlouiscardinals_suites: "DZ7sKaLQ5qgFtUCJL9IHBEg62RhgGR5YsKp5Mibjw0aoa7U7",
  winnipegjets_flex_sandbox: "9905940d1e7e.seasonshare.integ3-sandbox.us",
  gwinnettstripers_flex: "8f53ebdb774b.seasonshare.gwinnettstripers-dbh.us",
  houstonastros_suites: "faScHIOGdC3u5J9JNOD8NnSaP1VIwdcOZS5MVFf7yNG79Y7u",
  binghamtonrumbleponies_flex: "OnGQb10BcA76UxZQGn2X0bTZp5cHgcSA6nQYDqaj6YhuYJZH", // prettier-ignore
  aviators_flexpack: "7aada002426d.seasonshare.aviatorslv-vegas51s.us",
  albuquerqueisotopes_flexpack: "07ddf826a301.seasonshare.isotopes-isotopes.us",
  renoaces_suites: "PuOtdW484GoIrAHaAk4cOonU8lChoAMhIxHISLT1sWZyfVc9",
  newyorkyankees_suites: "f6bde69252f3.seasonshare.nyyreg-nyyankees.us",
  newyorkyankees_suites_iomedia: "f6bde69252f3.seasonshare.nyyreg-nyyankees.us",
  livenation_ruoffmusiccenter: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  livenation_midfloridasuites: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  flex_sandbox_groups: "9905940d1e7e.seasonshare.integ3-sandbox.us",
  memphisredbirds_flexpack: "wSIWJgwyB94f2NEKsfAOfG94jHnalA7euJpLtU56YeVih4Ys",
  sanantoniofc_suites: "f8bb7bfe9c46.seasonshare.spurs-spurs.us",
  tricitydustdevils_flex: "BtjB73zLcg4EtTxyFX22VO1czV9t2KTroTwxUJFtOAHA9sZS",
  dbacks_groups: "64dd97c850f6.seasonshare.azdbacks-azdbacks.us",
  orlandomagic_10pack: "2af95a60a522.seasonshare.magic-magic.us",
  tampabayrays_suites: "HDVp1GHQaeQKf09GmPKqaeAu2EJnqPcfILCBJBhPcsuzp24I",
  brooklyncyclones_flex: "uPFZJyK8Xd0qJbOddCh2YKEjOEh6mMDMaVC4dHExoxCF65pT",
  texasrangers_sandbox: "XATXJLZGaKgqGHjcRraofrbPdAfiGn8e",
  stlouiscardinals_sandbox: "XATXJLZGaKgqGHjcRraofrbPdAfiGn8e",
  sacramentokings_flex_sandbox: "9905940d1e7e.seasonshare.integ3-sandbox.us",
  rcquakes_flex: "I0ARDkuBf6J8czekcBuekl9djBFR0wBk1vFZc0AItajQwohT",
  newyorkyankees_flex: "f6bde69252f3.seasonshare.nyyreg-nyyankees.us",
  atlantahawks_suites: "a8b399c349c9.seasonshare.hawks-atl_spirit.us",
  livenation_hollywoodcasinostl_suites: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us", // prettier-ignore
  livenation_midflorida_suites: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  livenation_pncmusicpavilion_suites: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us", // prettier-ignore
  livenation_xfinitycenter_suites: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us", // prettier-ignore
  livenation_darienlake_suites: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  livenation_talkingstickresort_suites: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us", // prettier-ignore
  livenation_skylacreditunion_suites: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  livenation_bankofnewhampshire_suites: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us", // prettier-ignore
  livenation_pncbankartscenter_suites: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us", // prettier-ignore
  livenation_coastalcreditunion_suites: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us", // prettier-ignore
  bankofnewhampshire_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  coastalcreditunion_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  darienlake_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  hollywoodcasinostl_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  midflorida_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  pncbankartscenter_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  pncmusicpavilion_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  skylacreditunion_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  talkingstickresort_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  xfinitycenter_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  cascadesamphitheater_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  veteransunited_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  whiteriveramphitheatre_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  freedommortgagepavilion_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  dosequispavilion_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  creditunion1_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  jiffylubelive_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  pavilionatstarlake_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  northislandcreditunion_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  newyorkyankees_bananas_suites: "f6bde69252f3.seasonshare.nyyreg-nyyankees.us",
  winnipegjets_passport: "0b4fc428390a.seasonshare.tnse-truenorth.ca",
  huntingtonbank_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  jaguars_pack: "70b79cf58110.seasonshare.jaguars-jaguars.us",
  sackings_flexbank: "6b6c129ee955.seasonshare.sackings-sackings.us",
  msg: "14722a2f1643.seasonshare.msg-msg.us",
  milwaukeebucks_flex: "f98b35cae3b7.seasonshare.bucks-milwaukeebucks.us",
  sandbox_accountrep: "9905940d1e7e.seasonshare.integ3-sandbox.us",
  calgary_flexbank: "0ba48d4cb8e2.seasonshare.hitmen-flames.ca",
  philadelphiaflyers_flex: "9a006a7779bb.seasonshare.spectacor-flyers.us",
  ascendamphitheater_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  shorelineamphitheatre_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  utahfirst_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  newyorkyankees_suites_postseason: "f6bde69252f3.seasonshare.nyyreg-nyyankees.us", // prettier-ignore
  columbusbluejackets_suites: "c03246615459.seasonshare.bluejackets-bluejack.us", // prettier-ignore
  atlantadream_flex: "1263b29b9528.seasonshare.wnbaatlanta-dream.us",
  atlantahawks_flex: "a8b399c349c9.seasonshare.hawks-atl_spirit.us",
  pittsburghpenguins_flex: "3381f93f523d.seasonshare.penguins-penguins.us",
  fillmoresilverspring_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  oakdaletheatre_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  brooklynnets_packs: "b8dc1b4eeef2.seasonshare.bse-bse.us",
  winnipegjets_gamepack: "0b4fc428390a.seasonshare.tnse-truenorth.ca",
  placedesarts_giftcard: "642ed700fcea.seasonshare.pda-pda.ca",
  cincinnatireds_suites: "EU0bwooqRwqAPkJ2PL3PqzADQq1ldPIEvo7E1enCJRi71giD",
  cincinnatireds_bananas_suites:
    "EU0bwooqRwqAPkJ2PL3PqzADQq1ldPIEvo7E1enCJRi71giD",
  phoenixsuns_flex: "e992dca28572.seasonshare.suns-suns.us",
  newyorkyankees_bananas_flex: "f6bde69252f3.seasonshare.nyyreg-nyyankees.us",
  dbacks_miniplans: "64dd97c850f6.seasonshare.azdbacks-azdbacks.us",
  dbacks_miniplanscomp: "64dd97c850f6.seasonshare.azdbacks-azdbacks.us",
  coloradorockies_flex: "2aa19bec0e80.seasonshare.corockies-corockies.us",
  sacramentorivercats_flex: "718647ae2caa.seasonshare.rivercats-rivercats.us",
  torontobluejays_flex: "87732f0f5431.seasonshare.tbjrc-tbjrc.ca",
  torontobluejays_groups: "87732f0f5431.seasonshare.tbjrc-tbjrc.ca",
  sanantoniospurs_holiday: "f8bb7bfe9c46.seasonshare.spurs-spurs.us",
  mountainwest_flex: "800f2799df20.seasonshare.mountainwest-mwtickets.us",
  phoenixsuns_flexbundle: "e992dca28572.seasonshare.suns-suns.us",
  coloradorockies_groups: "2aa19bec0e80.seasonshare.corockies-corockies.us",
  northwestarkansasnaturals_flex: "0UUFMFyx1HG3uTR4P9lxUReKmhDdgJf2uYLlRYczJgBb55f3", // prettier-ignore
  northwestarkansasnaturals_gamepacks: "0UUFMFyx1HG3uTR4P9lxUReKmhDdgJf2uYLlRYczJgBb55f3", // prettier-ignore
  nationwidearena_suites: "c03246615459.seasonshare.bluejackets-bluejack.us",
  pennstate_suites: "876afb4f0332.seasonshare.pennstate-psuica.us",
  orlandocitysc_flex: "243d7986d1b1.seasonshare.ocsoccer-oclions.us",
  orlandopride_flex: "243d7986d1b1.seasonshare.ocsoccer-oclions.us",
  mlb_flex: "XATXJLZGaKgqGHjcRraofrbPdAfiGn8e",
  dbacks_groupspaces: "64dd97c850f6.seasonshare.azdbacks-azdbacks.us",
  prudentialcenter_suites: "8f3880de99a0.seasonshare.devils-devils.us",
  phoenixmercury_flex: "04c8d57360eb.seasonshare.mercury-mercury.us",
  aviators_groups: "7aada002426d.seasonshare.aviatorslv-vegas51s.us",
  saltlakebees_suites: "153bfc837d7c.seasonshare.slbees-slbees.us",
  philadelphia76ers_suites: "c244269e0844.seasonshare.sixers-sixers.us",
  dbacks_specialeventsuites: "64dd97c850f6.seasonshare.azdbacks-azdbacks.us",
  gorge_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  orlandomagic_20pack: "2af95a60a522.seasonshare.magic-magic.us",
  toyotaamphitheatre_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  toyotapavilion_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  lakewoodamphitheatre_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  montagemountain_premium: "ee451876b9e7.seasonshare.lnsfl1-lnoo.us",
  orlandomagic_fullseason: "2af95a60a522.seasonshare.magic-magic.us",
  iowastate_tents: "19a40b80a8b7.seasonshare.isu-isu.us",
};
